module.exports = __webpack_public_path__ + "static/media/icr-sponsor.a005144d.jpeg";